import * as React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box, { BoxProps } from "@mui/material/Box";
import { Link } from "gatsby";

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary">
      © 2018-{new Date().getFullYear()} Cronicle Press LLC. All Rights Reserved.
      All text and photos not attributed copyright Cronicle Press. This content
      may not be copied or distributed except in excerpt with permission.
    </Typography>
  );
}

interface FooterProps {
  description: string;
  title: string;
}

export function Footerblah(props: FooterProps) {
  const { description, title } = props;

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "background.paper",
        py: 6,
      }}
    >
      <Grid container maxWidth="lg">
        <Grid item md={3}>
          <Copyright />
        </Grid>
      </Grid>
    </Box>
  );
}

function Item(props: BoxProps) {
  const { sx, ...other } = props;
  return (
    <Box
      sx={{
        p: 1,
        m: 1,
        ...sx,
      }}
      {...other}
    />
  );
}

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "background.paper",
        py: 6,
      }}
    >
      <Grid container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            p: 1,
            m: 4,
          }}
        >
          <Item sx={{ flexGrow: 1 }}>
            <Copyright />
          </Item>
          <Item>
            <Typography variant="body2" color="text.secondary">
              <Link to="/code-of-conduct">Code of Conduct</Link>
            </Typography>
          </Item>
          <Item>
            <Typography variant="body2" color="text.secondary">
              <Link to="/privacy-policy">Privacy Policy</Link>
            </Typography>
          </Item>
          <Item>
            <Typography variant="body2" color="text.secondary">
              <Link to="/contact">Contact</Link>
            </Typography>
          </Item>
        </Box>
      </Grid>
    </Box>
  );
}
